import React, { useState, useEffect, useRef } from 'react'


import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  node,
  bool,
  func,
  string,
  oneOfType,
  number,
  object,
} from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

function Popover({
  content,
  offsetRight,
  openPopover = false,
  onPopoverTrigger = null,
  customClass = '',
  wrapperClass = '',
  children,
  triggerClass = '',
  triggerAttributes = EMPTY_OBJECT,
}) {
  const [isActive, setIsActive] = useState(openPopover)
  const stateRef = useRef(isActive)
  const wrapperRef = useRef(null)
  const popoverClass = `popover ${customClass}`

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    /* eslint-disable-next-line no-undef */
    App.events.subscribe('top:menu:popover:hide', setInactive)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      /* eslint-disable-next-line no-undef */
      App.events.remove('top:menu:popover:hide', setInactive)
    }
  }, [])

  useEffect(() => {
    setIsActive(openPopover)
  }, [openPopover])

  function updateState(val) {
    stateRef.current = val
    setIsActive(val)
  }

  function hideIndicator() {
    /* eslint-disable-next-line no-undef */
    App.events.publish('top:menu:indicator:hide')
  }

  function handleClickOutside(e) {
    hideIndicator()

    const currentRef = wrapperRef.current

    if (currentRef && !currentRef.contains(e.target) && stateRef.current) {
      updateState(false)
    }
  }

  function triggerPopover() {
    if (isActive) {
      return updateState(false)
    }

    hideIndicator()
    updateState(true)

    if (onPopoverTrigger) {
      onPopoverTrigger(true)
    }

    return null
  }

  function setInactive() {
    return setIsActive(false)
  }

  return (
    <div className={classnames('popover-container', wrapperClass)} ref={wrapperRef}>
      <div
        className={triggerClass}
        onClick={triggerPopover}
        {...triggerAttributes}
      >
        {children}
      </div>

      <div
        className={isActive ? `${popoverClass} is-active` : popoverClass}
        style={{ right: offsetRight }}
      >
        {content}
      </div>
    </div>
  )
}

Popover.propTypes = {
  content: node.isRequired,
  offsetRight: oneOfType([string, number]),
  openPopover: bool,
  onPopoverTrigger: func,
  customClass: string,
  wrapperClass: string,
  triggerClass: string,
  triggerAttributes: object,
}

export default Popover
